module.exports = __webpack_public_path__ + "img/img27.4c17db76.jpg";